<template>
  <aw-dropdown
    placement="bottom-start"
    :offset="[0, 6]"
    class="cursor-pointer inline-flex items-center"
  >
    <template v-slot:btn="{ toggle }">
      <div @click="toggle" class="inline-flex gap-x-2 items-center select-none">
        <slot name="heading">Some heading ...</slot>
        <aw-icon
          icon="chevron-down"
          class="w-4 h-4 -mx-1 "
        ></aw-icon>
      </div>
    </template>
    <template v-slot:dropdown="{ opened, dropdown, close }">
      <div
        v-show="opened"
        :ref="dropdown"
        class="Dropdown Dropdown--Hover absolute rounded-md bg-white max-w-xs text-sm top-full right-0 shadow-md z-10"
        @click.stop="close"
      >
        <slot name="content"></slot>
      </div>
    </template>
  </aw-dropdown>
</template>

<script>
export default {}
</script>
